import React from 'react';
import loadable from 'sku/@loadable/component';

import { isServerRendering } from 'src/app/utils/environment';

import { getUivQueryParam } from './utils/getUivQueryParam';
import { getUivInStorage } from './utils/sessionStorage';

const Banner = loadable(
  () =>
    import('src/app/shared/components/UivController/components/Banner').then(
      (module) => ({
        default: module.Banner,
      }),
    ),
  { ssr: false },
);

const hasUivSet = getUivQueryParam() || getUivInStorage();

export const UivController = () =>
  !isServerRendering() && hasUivSet ? <Banner /> : null;
